import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { requestViewEWalletEntries } from '../../../api/e-wallet/e-wallet.actions';

import EWallet from '../../../components/screens/shop/e-wallet/EWallet';

const EWalletContainer = () => {
  const { entries } = useSelector(({ eWallet }) => eWallet);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(requestViewEWalletEntries());
  }, [dispatch]);

  return <EWallet entries={entries} />;
};

export default EWalletContainer;
